var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticStyle:{"padding-top":"6px"},attrs:{"inset":"","app":"","height":"auto"}},[_c('div',{staticStyle:{"text-align":"center","flex-grow":"1"}},[_c('AVersionInfo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }